import React, {useState} from 'react';
import './SignUpText.css';
import NormalBtn from './NormalBtn';

export default function App(props) {

  var infoPieces = props.origInfo.v;

  var title = infoPieces[1].v;
  var endMessage = infoPieces[3].v;
  var formInfo = infoPieces[2];
  var programName = infoPieces[4].v;

  var pieces = formInfo.v[1].v.map((aVariable, index)=>{
    var title = aVariable.v[0].v;
    var isEditable = aVariable.v[1].v;
    return {title, isEditable};
  })

  var initialResults = formInfo.v[2].v;
  var refNos = formInfo.v[3].v;

  var storage = pieces.map((aPiece, index)=>{
    if (initialResults.length > 0){
      var firstLine = initialResults[0];
      var text = "";
      if (firstLine.t === "string"){
        text = firstLine.v.charCodeAt(+index);
      }else{
        text = firstLine.v[+index].v;
      }
      if (text.length === 0){
        text = "";
      }
      return text;
    }else{
      return "";
    }
  });

  var titlePiece;
  if (title.length > 0){
    titlePiece = <div><b>{title}</b></div>
  }

  if (endMessage.length === 0){
    endMessage = "";
  }


  const [resultsStore, setResultsStore] = useState(storage);

  var submitFormInfo = props.submitFormInfo;
  var width = props.width;
  var adminAction = props.adminAction;

  // const [userName, setUserName] = useState(infoPieces[0].v);
  // const [postalCode, setPostalCode] = useState(infoPieces[1].v);
  // const [unitNos, setUnitNos] = useState(infoPieces[2].v);
  // const [addressLine, setAddressLine] = useState(infoPieces[3].v);
  // const [phoneNumber, setPhoneNumber] = useState(infoPieces[4].v);
 
  // var pieces = [{t:"Name", v:userName, f:setUserName, editable:true}, {t:"Postal Code", v:postalCode, f:setPostalCode, editable:true}, {t:"Unit Number", v:unitNos, f:setUnitNos, editable:true}, {t:"Address", v:addressLine, f:setAddressLine, editable:false}, {t:"Phone Number", v:phoneNumber, f:setPhoneNumber, editable:true}];

  function changeValue(whichPiece){
    return function(e){
      console.log(whichPiece);
      resultsStore[whichPiece] = e.target.value;
      console.log(resultsStore);
      setResultsStore(resultsStore);
    }
  }

  // function updateAddress(response){
  //   if (response.t === "binary"){
  //     setAddressLine(response.v);
  //   }else{
  //     setAddressLine("Unknown postal code");
  //   } 
  // }

  function onBlur(aPiece){
    return function(e){
      // if (aPiece.t === "Postal Code"){
      //   var trimPostal = postalCode.trim();
      //   adminAction("getAddressFromPostal", {postalCode:trimPostal}, updateAddress);
      // }    
    }    
  }

  var rows = pieces.map((aPiece, index)=>{
    var value = resultsStore[+index];
    var concreteText = <input key="constructorTerm" autoComplete="none" type="text" className="textFieldPieceNoColor" style={{width:"80%"}} placeholder="" defaultValue={value} onChange={changeValue(+index)} onBlur={onBlur(aPiece)} />
    if (!aPiece.isEditable){
      concreteText = <div>{value}</div>
//
    }
    return <tr key={index}><td>{aPiece.title}</td>
            <td>{concreteText}</td>
          </tr>
  })
//
  function submitPiece(){
    // for (var i = 0; i < pieces.length; i++){
    //   var aPiece = pieces[i];
    //   if (aPiece.v.trim() === ""){
    //     window.alert(aPiece.t + " cannot be blank");
    //     return;
    //   }
    // }

    // if (addressLine === "Unknown postal code"){
    //   window.alert("Sorry, we do not recognize this postal code");
    //   return;
    // }

    var p = true;
    if(endMessage){
      p = window.confirm(endMessage);
    }
    if (p){
      var resultsOut = resultsStore.map((aResult, index)=>{
        return {v:aResult};
      })
      submitFormInfo(resultsOut, programName, refNos); //get form name.
    }

  }

  var buttonRow = [];
  buttonRow.push(<NormalBtn onClick={submitPiece} title="Submit" />)
  var style = {};
  if (width){
    style.width = width * 0.8;
  }
    return (<div style={style}>
              {titlePiece}
              <table width="100%">
                <tbody>
                  {rows}
                </tbody>
              </table>
              {buttonRow}
            </div>
    );
  
}

